/* @flow */
import type { Node } from 'react';
import React from 'react';
import { LikeButtons, LikeButtonsWrapper } from './styles';
import CompareBtn from '../CompareBtn';
import ShareBtn from '../ShareBtn';
import { addDataLayer } from '../../utils';

type TProps = {
	apartId: string,
	isMobile: boolean,
};

const CompareShareBtns = ({ apartId, isMobile }: TProps): Node => {
	const seoShareEvent = (eventAction) => {
		addDataLayer({
			event: 'customTrackEvent',
			eventCategory: 'share',
			eventAction,
			eventLabel: apartId,
		});
	};

	return (
		<LikeButtonsWrapper>
			<LikeButtons>
				<CompareBtn dataQa="apart_compare_btn" id={apartId} mode="Side" color="transparentGray" />
				<ShareBtn
					dataQa="apart_share_btn"
					mode="Side"
					iconSize={isMobile ? 24 : 32}
					seoShareEvent={seoShareEvent}
					color="transparentGray"
				/>
			</LikeButtons>
		</LikeButtonsWrapper>
	);
};
export default CompareShareBtns;
